import React from 'react'
// hooks
import { formatDateValue, useDatePicker } from 'hooks/useDatePicker'
// components
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker'

export interface CustomDatePickerProps extends Omit<DatePickerProps<any>, 'onChange' | 'label'> {
  label?: string
  error?: boolean
  onChange: (value: string) => void
  required?: boolean
  clearable?: boolean
  dateFormat?: string
}

const DatePickerComponent: React.FC<CustomDatePickerProps> = ({
  value,
  label,
  error,
  minDate,
  maxDate,
  onChange,
  required,
  clearable,
  dateFormat,
  ...rest
}) => {
  const { props } = useDatePicker({
    value,
    label,
    error,
    required,
    onChange,
    shouldTrimTz: true
  })

  return (
    <DatePicker
      {...rest}
      {...props}
      format={dateFormat || 'DD MM YYYY'}
      minDate={formatDateValue(minDate)}
      maxDate={formatDateValue(maxDate)}
      slotProps={{
        ...props.slotProps,
        ...(clearable && { field: { clearable: true, onClear: () => onChange(null) } })
      }}
    />
  )
}

export default DatePickerComponent
